import { ReactSimpleComponentProps } from '@/custom-types'
import {
  AddContactFormModalContext,
  AddContactFormModalContextProps,
} from './AddContactFormModalContext'
import { ContactOutput } from '@/graphql/generated'
import { useMemo, useRef, useState } from 'react'

export const AddContactFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
const contactRef = useRef<ContactOutput | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddContactFormModalContextProps, 'contactData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      contactRef.current = null
    },

    openModal: (contactData?: ContactOutput) => {
      setOpen(true)

      if (contactData) contactRef.current = contactData
    }
  }), [])

  return (
    <AddContactFormModalContext.Provider value={{ ...actions, isOpen, contactData: contactRef.current}}>
      {children}
    </AddContactFormModalContext.Provider>
  )
}